(function () {
  const EXPERIMENT_ID = 'Style_With';
  const CONTROL_GROUP = 'a';
  const EXPERIMENT_GROUP = 'b';
  const MOBILE_QUERY = '(max-width: 749px)';

  if (window.__fabriqueStyleWithABInitialized) return;
  window.__fabriqueStyleWithABInitialized = true;

  function normalizeGroup(value) {
    return value === EXPERIMENT_GROUP ? EXPERIMENT_GROUP : CONTROL_GROUP;
  }

  function getExperimentGroup(timeout) {
    return new Promise((resolve) => {
      const startedAt = Date.now();

      function check() {
        try {
          const value = window._growthbook?.getFeatureValue?.(EXPERIMENT_ID, null);
          if (value !== null && value !== undefined && value !== '') {
            resolve(normalizeGroup(value));
            return;
          }
        } catch (error) {
          resolve(CONTROL_GROUP);
          return;
        }

        if (Date.now() - startedAt >= timeout) {
          resolve(CONTROL_GROUP);
          return;
        }

        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function getSwiperOptions() {
    const options = {
      direction: 'horizontal',
      slidesPerView: 'auto',
      freeMode: true,
      grabCursor: true,
    };

    if (typeof window.isSafariPC === 'function' && !window.isSafariPC()) {
      options.mousewheel = { forceToAxis: true };
    }

    return options;
  }

  function ensureSwiper(module) {
    const swiperElement = module.querySelector('.fabrique-product-complete-look-swiper');
    if (!swiperElement || swiperElement.swiper || typeof window.Swiper !== 'function') return;

    new window.Swiper(swiperElement, getSwiperOptions());
  }

  function destroySwiper(module) {
    const swiperElement = module.querySelector('.fabrique-product-complete-look-swiper');
    const swiper = swiperElement?.swiper;
    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
    }
  }

  function applyImage(module, group) {
    const image = module.querySelector('[data-style-with-image]');
    if (!image) return;

    const source = group === EXPERIMENT_GROUP
      ? image.dataset.styleWithMatchImage || image.dataset.styleWithFallbackImage
      : image.dataset.styleWithControlImage;

    if (!source) return;

    image.setAttribute('src', source);
    image.removeAttribute('srcset');
  }

  function applyCardAttribution(module, group) {
    module.querySelectorAll('[data-style-with-item] .fabrique-product-wrapper').forEach((card) => {
      card.dataset.abExperimentId = EXPERIMENT_ID;
      card.dataset.abGroup = group;
      card.dataset.abVariant = group;
      card.dataset.abSlideFeatureId = EXPERIMENT_ID;
      card.dataset.trackAbtestExperimentId = EXPERIMENT_ID;
      card.dataset.trackAbtestExperimentGroup = group;
    });
  }

  function applyLayout(module, group) {
    const useMobileExperimentLayout =
      group === EXPERIMENT_GROUP && window.matchMedia(MOBILE_QUERY).matches;

    module.classList.toggle('style-with--control', group === CONTROL_GROUP);
    module.classList.toggle('style-with--experiment', group === EXPERIMENT_GROUP);
    module.classList.toggle('style-with--experiment-mobile', useMobileExperimentLayout);
    module.dataset.trackModuleType = useMobileExperimentLayout ? 'list_grid' : 'list_horizontal';

    if (useMobileExperimentLayout) {
      destroySwiper(module);
    } else {
      ensureSwiper(module);
    }
  }

  function applyGroup(module, group) {
    module.dataset.abExperimentId = EXPERIMENT_ID;
    module.dataset.abGroup = group;
    applyImage(module, group);
    applyCardAttribution(module, group);
    applyLayout(module, group);
    module.hidden = false;
  }

  function init() {
    const modules = Array.from(document.querySelectorAll('[data-style-with-module]'));
    if (!modules.length) return;

    getExperimentGroup(3000).then((group) => {
      modules.forEach((module) => applyGroup(module, group));

      window.addEventListener('resize', () => {
        modules.forEach((module) => applyLayout(module, group));
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
